import { Reveal } from "@components/ui";

const cards = [
  {
    title: "Safety Awareness",
    description:
      "Regular community workshops on gas safety, leak detection, and emergency procedures",
    color: "#122d63",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
  },
  {
    title: "School Programs",
    description:
      "Educational initiatives bringing energy awareness to the next generation",
    color: "#1a7a4f",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      </svg>
    ),
  },
  {
    title: "Customer Education",
    description:
      "Guides, tips, and resources helping customers use energy efficiently",
    color: "#d4880f",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 18h6" />
        <path d="M10 22h4" />
        <path d="M12 2a7 7 0 0 1 4 12.9V17H8v-2.1A7 7 0 0 1 12 2z" />
      </svg>
    ),
  },
  {
    title: "Industry Partnerships",
    description:
      "Collaborating with regulators and peers to advance safety standards",
    color: "#6b4fc7",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z" />
        <path d="M12 5.36 8.87 8.5a2.13 2.13 0 0 0 0 3h0a2.13 2.13 0 0 0 3 0l2.26-2.21a3 3 0 0 1 4.22 0l2.07 2.08" />
      </svg>
    ),
  },
];

const CommunityEngagementSection = () => {
  return (
    <section className="bg-white py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal>
          <div className="text-center mb-12 lg:mb-16">
            <span className="inline-block rounded-full bg-[#fef3e8] px-4 py-1.5 text-sm font-medium text-[#d4880f] mb-4">
              Community
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-[42px] font-bold text-[#090d2c] leading-tight mb-4">
              Empowering Communities With Knowledge
            </h2>
            <p className="text-[#62636c] text-base md:text-lg max-w-[640px] mx-auto">
              Building awareness for a safer, more sustainable future
            </p>
          </div>
        </Reveal>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {cards.map((card) => (
            <Reveal key={card.title}>
              <div className="group relative rounded-[24px] bg-white border border-gray-200 p-6 md:p-8 overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
                {/* Top colored bar */}
                <div
                  className="absolute top-0 left-0 right-0 h-1 rounded-t-[24px]"
                  style={{ backgroundColor: card.color }}
                />

                {/* Icon circle */}
                <div
                  className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
                  style={{
                    backgroundColor: `${card.color}15`,
                    color: card.color,
                  }}
                >
                  {card.icon}
                </div>

                <h3 className="text-lg md:text-xl font-bold text-[#090d2c] mb-2">
                  {card.title}
                </h3>
                <p className="text-[#62636c] text-sm md:text-base leading-relaxed">
                  {card.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommunityEngagementSection;
